import type { HotelLoyaltyPrograms } from '@voll-intelligence/domain';

/** Uma linha por programa de hotel, `Rede · número`. Vazio para null/sem programas. */
export function hotelLoyaltyLines(programs: HotelLoyaltyPrograms | null | undefined): string[] {
  return (programs?.programs ?? []).map((p) => `${p.chainName} · ${p.number}`);
}
